import * as styles from "./SearchInput.module.scss";

import React, { useMemo, useState } from "react";

import { navigate } from "gatsby";
import { TextInput, type TextInputProps } from "../../components/common";
import { Search } from "../common/Icons";

export interface SearchInputProps extends TextInputProps {
	title: string;
	baseSearchUrl: string;
	justInput: boolean;
}
export const SearchInput: React.FC<SearchInputProps> = ({
	title,
	baseSearchUrl,
	justInput = false,
	onChange,
	...props
}) => {
	const [searchTerm, setSearchTerm] = useState("");

	const searchUrl = useMemo(
		() => `${baseSearchUrl}?q=${searchTerm}`,
		[baseSearchUrl, searchTerm],
	);

	if (justInput)
		return (
			<div className={styles.searchinputwrapper}>
				<div className={styles.search}>
					<TextInput
						{...props}
						className={styles.searchinput}
						IconRight={Search}
						onIconRightCallback={() => navigate(searchUrl)}
						iconRightDimensions={"28px"}
						onChange={(e) => {
							onChange?.(e);
							setSearchTerm(e.currentTarget.value);
						}}
						value={searchTerm}
						onEnterCallback={() => navigate(searchUrl)}
					/>
				</div>
			</div>
		);
	return (
		<div className={styles.searchinputwrapper}>
			<div className={styles.search}>
				<header className={styles.searchtitlecontainer}>
					<h2 className={styles.searchtitle}>{title}</h2>
				</header>
				<TextInput
					{...props}
					className={styles.searchinput}
					IconRight={Search}
					onIconRightCallback={() => navigate(searchUrl)}
					iconRightDimensions={"28px"}
					onChange={(e) => {
						onChange?.(e);
						setSearchTerm(e.currentTarget.value);
					}}
					value={searchTerm}
					onEnterCallback={() => navigate(searchUrl)}
				/>
			</div>
		</div>
	);
};

export default SearchInput;
